module.exports = __webpack_public_path__ + "img/icon-mytarget-new.169c3f8b.svg";